<template>
  <div class="order">
    <Detail />

    <div v-if="this.$route.params.type == 1">
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          style="border-radius: 40px"
          v-model="form.phone"
          type="tel"
          placeholder="请输入手机号"
        />
      </div>
      <div
        style="
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.random"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              v-if="dd == false"
              @click="change"
              round
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 2">
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          style="border-radius: 40px"
          v-model="form.name"
          placeholder="请输入姓名"
        />
      </div>
      <div
        style="
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.phone"
          center
          style="border-radius: 40px"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div
        style="
          border-radius: 40px;
          margin-top: 20px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.random"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              v-if="dd == false"
              @click="change"
              round
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 3">
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          style="border-radius: 40px"
          v-model="form.name"
          placeholder="请输入姓名"
        />
      </div>
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.phone"
          center
          style="border-radius: 40px"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div
        style="
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.identityCard"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入身份证号"
        ></van-field>
      </div>
      <div
        style="
          border-radius: 40px;
          margin-top: 20px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.random"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              v-if="dd == false"
              @click="change"
              round
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div v-if="this.$route.params.type == 4">
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          style="border-radius: 40px"
          v-model="form.name"
          placeholder="请输入姓名"
        />
      </div>
      <div
        style="
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.phone"
          center
          style="border-radius: 40px"
          clearable
          type="tel"
          placeholder="请输入手机号"
        ></van-field>
      </div>
      <div
        style="
          margin: 20px 0;
          border-radius: 40px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.identityCard"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入身份证号"
        ></van-field>
      </div>
      <div
        style="
          border-radius: 40px;
          margin-top: 20px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        "
      >
        <van-field
          v-model="form.random"
          center
          style="border-radius: 40px"
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              v-if="dd == false"
              @click="change"
              round
              type="info"
            >
              验证码
            </van-button>
            <van-button size="small" v-if="dd" disabled round>
              <van-count-down
                ref="count0"
                :time="time"
                :auto-start="false"
                format="ss"
                @finish="finishss"
              />
            </van-button>
          </template>
        </van-field>
      </div>
    </div>
    <van-button
      style="margin: 20px 0; width: 100%"
      @click="changse"
      size="medium"
      round
      type="info"
    >
      确认提交
    </van-button>
  </div>
</template>

<script>
  // // import { Loading } from "element-ui";
  import { VerificationCode, updateRealType } from "@/api/cardOperation";
  import Detail from "@/components/Detail.vue";
  export default {
    data() {
      return {
        form: {
          random: "",
          phone: "",
          meCardNum: localStorage.getItem("meCardNum"),
          identityCard: "",
          name: "",
        },
        dd: false,

        time: 60 * 1000,
      };
    },
    created() {
      console.log(this.$route.params);
    },
    methods: {
      finishss() {
        this.dd = false;
      },
      start() {
        this.$nextTick(() => {
          this.$refs.count0.start();
        });
      },

      change() {
        if (this.form.phone == "") {
          this.$notify({
            type: "warning",
            message: `手机号不能为空`,
          });
        } else {
          VerificationCode(this.form.phone).then((res) => {
            if (res.status) {
              console.log(res);
              this.$notify({
                type: "success",
                message: res.msg,
              });
              this.dd = true;
              this.start();
            } else {
              this.$notify({
                type: "warning",
                message: res.msg,
              });
            }
          });
        }
      },
      changse() {
        updateRealType(this.form).then((res) => {
          if (res.status) {
            if (this.$route.params.mk) {
              this.$router.push({
                path: "/recharges",
                query: {
                  card: this.values,
                },
              });
            } else {
              this.$router.push({
                path: "/home",
                query: {
                  card: this.values,
                },
              });
            }

            this.$notify({
              type: "success",
              message: res.msg,
            });
          } else {
            this.$notify({
              type: "warning",
              message: res.msg,
            });
          }
        });
      },
    },
    watch: {},
    computed: {},
    components: {
      Detail,
    },
  };
</script>

<style lang="scss" scoped>
  .order {
    padding: 20px;

    .detail {
      width: 100%;
      margin: 20px 0;
      border-radius: 20px;
      padding-top: 10px;
      padding-bottom: 20px;
      box-sizing: border-box;
      box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
      background-color: rgba(128, 128, 128, 0.1);
    }
  }
</style>
